import * as _ from "lodash";
import {DocumentType as Utils} from '../../utils/validators';

interface Action {
    payload: any,
    type: string,
    uploads?: any,
    field: {
        val: string,
        legend?: any
    }
}

const initialState: any = {
    action: '',
    uploads: [],
    validItems: [],
    invalidItems: []
};

const baseState = _.cloneDeep(initialState);


const DocumentsReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'FILES_CHECK':
            state.action = action.type;
            return Utils.Validator({...state}, action);
        case 'FILES_RESET':
            state.action = action.type;
            return Utils.Reset({...state}, {...action});
        case 'FILE_UPLOAD':
            state.action = action.type;
            state.uploads = state.uploads.concat(action.payload.data || []);
            return state;
        case 'FILE_DELETE':
            state.action = action.type;
            return state;
        case 'FILES_RESET_ALL':
            state.action = action.type;
            return _.cloneDeep(baseState);
        case 'FILES_DEFAULT':
            state.action = action.type;
            state.uploads = state.uploads.concat(action.payload || []);
            return state;
        case 'FILE_LOADING':
            state.action = action.type;
            return {
                ...state,
                fileLoading: action.payload
            };
        default:
            return state;
    }
};

export default DocumentsReducer;
